import axios, { AxiosInstance, AxiosRequestConfig, InternalAxiosRequestConfig } from 'axios';
import { v4 as uuidv4 } from 'uuid';
import { GrouperServiceConverter } from 'src/services/converters/GrouperServiceConverter';

/**
 * Service for interacting with the backend Grouper V3 service.
 */
export class GrouperService {
  private axiosInstance: AxiosInstance;
  private visitId: number | undefined;
  private facilityCode: string | undefined;

  constructor() {
    this.axiosInstance = axios.create();
    this.axiosInstance.interceptors.request.use(
      (config: InternalAxiosRequestConfig) => {
        config.headers['x-request-id'] = uuidv4();
        return config;
      }
    );
  }

  setAxiosConfig(baseUrl: string, visitId: number, facilityCode: string) {
    this.setBaseUrl(baseUrl);
    this.visitId = visitId;
    this.facilityCode = facilityCode;
  }

  async getGrouperData() {
    // TODO - how should we handle the response type? eslint complains about any types.
    const response =  this.axiosCall<any>({
      method: 'get',
      url: `/visit/${this.visitId}/grouper_v3`,
    });

    return GrouperServiceConverter.convertGrouperData(response);
  }

  private setBaseUrl(url: string) {
    this.axiosInstance.defaults.baseURL = url;
  }

  private async axiosCall<T>(config: AxiosRequestConfig) {
    try {
      const {data} = await this.axiosInstance.request<T>(config);
      return {err: null, data};
    } catch (err) {
      return {err};
    }
  }

}

export const grouperService = new GrouperService();
